"use strict";

import angular from "angular";

import _ from "lodash";
import { Events } from "../../../presentation/services/Events/Events";
export class AnonymousReportDialogCtrl {
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;

        this.Events = new Events();

        this.formModel = { name: "", email: "" };
    }

    onSubmit() {
        this.Events.setParamns({
            anonimo: this.formModel.email,
            companyId: _.get(this.locals, "report.companyId"),
            accountingId: _.get(this.locals, "report.accountingId")
        });

        const types = {
            balance: "Balanco",
            dashboard: "Dashboard",
            dre: "DRE",
            dreComparation: "DRE.Comparacao",
            monitoring: "Monitoramento"
        };

        const type = types[_.get(this.locals, "report.type")] || "Dashboard";

        this.Events.send(
            `Relatorio.${type}.anonimo.acessar.${_.get(
                this.locals,
                "report.sources"
            )}`,
            {
                username: this.formModel.email,
                roles: "Anonimo",
                profile: {
                    accountingId: _.get(this.locals, "report.accountingId")
                }
            }
        );

        this.$mdDialog.hide({ ...this.formModel });
    }

    cancel() {}
}

angular
    .module("nucont.shared")
    .controller("AnonymousReportDialogCtrl", [
        "$mdDialog",
        "locals",
        AnonymousReportDialogCtrl
    ]);
